import { createSafeContext } from '@lib/utils/createSafeContext';

import type { CardSkin, ThemeConfig, ThemeMode, ThemePreset } from '@lib/types/theme';

export interface ThemeContextValue extends ThemeConfig {
  isDark: boolean;
  setThemeMode: (val: ThemeMode) => void;
  setPreset: (val: ThemePreset) => void;
  setCardSkin: (val: CardSkin) => void;
  resetTheme: () => void;
}

export const [ThemeContext, useThemeContext] = createSafeContext<ThemeContextValue>(
  'useThemeContext must be used within ThemeProvider'
);
